import React from "react";
import TabbedPage from "../shared/TabbedPage";
import translate from "../../../../i18n/translate";
import PermissionManager from "../../PermissionManager/PermissionManager";
import VerificationCodeLookup from "../VerificationCodeLookup";
import SellerOtpToggle from "../SellerOtpToggle";

// Who can do what, and help for a seller who cannot get in.
const AccessPage = ({ defaultTab }) => (
  <TabbedPage
    id="access"
    title={translate("Users & access")}
    intro={translate("accessHint")}
    defaultTab={defaultTab}
    tabs={[
      { key: "permissions", label: translate("Permissions"), render: () => <PermissionManager /> },
      { key: "loginCode", label: translate("Login Code"), render: () => <VerificationCodeLookup /> },
      { key: "skipLoginCode", label: translate("Skip Login Code"), render: () => <SellerOtpToggle /> },
    ]}
  />
);

export default AccessPage;
